























































import { LowElement } from '@/types/Element';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseOptions from './BaseOptions';

type LowProps = {
  gutter: number;
  type: 'flex' | undefined;
  justify: "start" | "end" | "center" | "space-around" | "space-between" | undefined;
  align: "top" | "middle" | "bottom" | undefined;
}

@Component({

})
export default class Row extends BaseOptions {

  get props () {
    return this.element ? this.element.props : null
  }

  rules = {

  };

  form: LowProps = {
    gutter: this.props ? this.props.gutter : 0,
    type: this.props ? this.props.type : undefined,
    justify: this.props ? this.props.justify : undefined,
    align: this.props ? this.props.align : undefined
  }

  timer: number = 0;

  @Watch('props')
  elementWatch (newVal: Element, oldVal: Element) {
    if (newVal === oldVal) return;

    this.form.gutter = this.props ? this.props.gutter : 0;
    this.form.type = this.props ? this.props.type : undefined;
    this.form.justify = this.props ? this.props.justify : undefined;
    this.form.align = this.props ? this.props.align : undefined
  }

  @Watch('form.type')
  formTypeWatch (newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      if (newVal === 'flex') {
        this.form.justify = 'start';
        this.form.align = 'top';
      } else {
        this.form.justify = undefined;
        this.form.align = undefined;
      }
    }
  }

  @Watch('form', { deep: true })
  formWatch (newVal: LowProps, oldVal: LowProps) {
    // 将参数添加进去
    this.handleUpdate();
  }
  handleUpdate () {
    this.$store.commit('page/UPDATE_CURRENT_PROPS', { ...this.form })
  }
  onSubmit () {

  }
  /**
   * 取消
   */
  handleClose () {
    this.$store.commit("page/SET_CURRENT", undefined);
  }

  handleRemove () {
    this.$store.commit("page/REMOVE_CURRENT");
    this.$store.commit("page/SET_CURRENT", undefined);
  }
}

